export const styles = {
    appHeaderContainer: {
        display: 'flex',
    },
    mainContentContainer: (open: boolean): any => ({
        flexGrow: 1,
        width: `calc(100% - ${open ? '200' : '100'}px)`,
        ml: open ? '200px' : '100px',
        height: '90vh',
        pt: 7,
        mr: 4,
    }),
    mainContent: {
        my: 2,
        p: 1,
        height: 'calc(100% - 16px)',
        overflowY: 'auto',
        borderRadius: '20px',
        backgroundColor: '#f7f9fa',
        marginLeft: '-1px',
    },
};
